import { useDrawer } from '@electricjs/arc';

/**
 * Custom hook for managing the AI Chat Drawer state
 *
 * This hook wraps the Arc useDrawer hook with specific configuration
 * for the AI chat drawer, making it easy to control from anywhere in the app.
 *
 * @returns Object containing drawer state and control functions
 */
export const useAIChatDrawer = () => {
  const drawer = useDrawer({
    placement: 'right',
    width: '40rem',
    backdrop: false,
    hideOnEsc: true,
    hideOnClickOutside: false, // Don't close when clicking outside
    preventBodyScroll: false,
  });

  return drawer;
};
